<template>
  <div class="message container">
    <NuxtTransformImage
      alt="Aimie portrait"
      :src="'/assets/artnight/homepage/aimie-portrait.png'"
      loading="lazy"
      fit="contain"
      sizes="xs:30vw sm:30vw md:10vw lg:200px xl:200px"
    />

    <div>
      <p class="message__text">{{ $t('homepage.message.text') }}</p>
      <p class="message__signature">{{ $t('homepage.message.signature') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
const NuxtTransformImage = defineAsyncComponent(() => import('@/components/molecules/NuxtTransformImage.vue'));
</script>

<style lang="scss" scoped>
@use '@/assets/styles/css_BASE/helpers/mixins/font-size.scss' as *;
@use '@/assets/styles/css_BASE/helpers/mixins/_bp.scss' as *;

.message {
  display: flex;
  margin: 20px;
  gap: 15px;

  @include bp(sm-up) {
    margin: 30px auto;
    align-items: center;
    gap: 25px;
  }
  @include bp(sm) {
    max-width: 90%;
    margin: 40px auto;
  }
  @include bp(md) {
    max-width: 900px;
    margin: 50px auto;
  }
  @include bp(md) {
    max-width: 900px;
    margin-bottom: 60px;
  }
  &__text {
    font-weight: 500;
    @include font-size(16px);
    line-height: 130%;
    letter-spacing: 0%;
    padding-bottom: 10px;
    @include bp(sm-up) {
      @include font-size(30px);
      letter-spacing: -2%;
      padding-bottom: 20px;
    }
  }
  &__signature {
    font-weight: 400;
    @include font-size(14px);
    line-height: 130%;
    letter-spacing: 0%;
  }

  img {
    max-height: 184px;
    @include bp(sm-up) {
      max-height: 322px;
      max-width: 271px;
    }
  }
}
</style>
